@for (modalState of activeModals(); track modalState.ref; let i = $index) {
  <div
    class="fixed inset-0 flex p-4"
    [style.z-index]="1000 + i * 10"
    [class.items-center]="modalState.options.centered"
    [class.items-start]="!modalState.options.centered"
    (keydown.escape)="onEscapeKey($event, modalState.ref)"
    tabindex="-1"
  >
    <button
      type="button"
      class="absolute inset-0"
      [ngClass]="
        isTopModal(modalState.ref)
          ? 'bg-slate-950/55'
          : 'bg-slate-950/35 pointer-events-none'
      "
      aria-label="Cerrar modal"
      (click)="onBackdropClick(modalState.ref)"
    ></button>

    <div
      class="relative z-10 mx-auto my-8 w-full rounded-2xl border border-slate-200 bg-white shadow-2xl"
      [ngClass]="getModalSizeClass(modalState.ref)"
      role="dialog"
      aria-modal="true"
    >
      <ng-container
        [ngTemplateOutlet]="modalState.template"
        [ngTemplateOutletContext]="{ $implicit: modalState.ref }"
      ></ng-container>
    </div>
  </div>
}
